var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3168 5.29726L9.24274 13.3712C8.43873 14.1752 6.05205 14.5476 5.51886 14.0144C4.98567 13.4812 5.34959 11.0946 6.15361 10.2906L14.2361 2.20812C14.4354 1.99066 14.6767 1.81586 14.9455 1.69424C15.2142 1.57262 15.5048 1.5067 15.7998 1.50048C16.0947 1.49428 16.3878 1.54789 16.6614 1.65809C16.9351 1.76829 17.1835 1.93281 17.3918 2.14169C17.6001 2.35056 17.764 2.59947 17.8734 2.87339C17.9828 3.14733 18.0357 3.44058 18.0287 3.73549C18.0217 4.03039 17.9549 4.32084 17.8326 4.58926C17.7102 4.85767 17.5348 5.09853 17.3168 5.29726Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.61699 3.26599H4.38533C3.48748 3.26599 2.62646 3.62265 1.99159 4.25753C1.35672 4.89241 1 5.75347 1 6.65132V15.1146C1 16.0125 1.35672 16.8736 1.99159 17.5084C2.62646 18.1433 3.48748 18.5 4.38533 18.5H13.695C15.5654 18.5 16.234 16.9766 16.234 15.1146V10.883",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.17732078.svg";
export { ForwardRef as ReactComponent };